module.exports = __webpack_public_path__ + "img/bookmark-plus-fill.865049d1.svg";